// app/scripts/events-filter.ts

interface EventsFilterData {
    ajaxUrl: string;
    nonce: string;
    defaultYear: number;
    action: string;
    i18n: {
        noEvents: string;
        loading: string;
        error: string;
    };
}

declare const eventsFilterData: EventsFilterData;

export default class EventsFilter {

    private select: HTMLSelectElement | null;
    private container: HTMLElement | null;

    constructor() {
        console.log('EventsFilter init');
        console.log('select:', document.getElementById('year-select'));
        console.log('container:', document.getElementById('events-list'));
        console.log('eventsFilterData:', typeof eventsFilterData !== 'undefined' ? eventsFilterData : 'NON DÉFINI');

        this.select    = document.getElementById('year-select') as HTMLSelectElement | null;
        this.container = document.getElementById('events-list') as HTMLElement | null;

        if (!this.select || !this.container) {
            return; // Pas sur la page événements
        }

        this.init();
    }

    private init(): void {
        // Chargement initial
        const initialYear = Number(this.select!.value) || eventsFilterData.defaultYear;
        void this.fetchEventsByYear(initialYear);

        // Changement de sélection
        this.select!.addEventListener('change', (event: Event) => {
            const target = event.target as HTMLSelectElement;
            const year   = Number(target.value);
            if (!year) return;

            const url = new URL(window.location.href);
            url.searchParams.set('year', String(year));
            window.history.replaceState(null, '', url.toString());

            void this.fetchEventsByYear(year);
        });

        // Bouton précédent du navigateur
        window.addEventListener('popstate', () => {
            const params      = new URLSearchParams(window.location.search);
            const yearFromUrl = Number(params.get('year'));

            if (yearFromUrl && this.select!.querySelector<HTMLOptionElement>(`option[value="${yearFromUrl}"]`)) {
                this.select!.value = String(yearFromUrl);
                void this.fetchEventsByYear(yearFromUrl);
            }
        });
    }

    private async fetchEventsByYear(year: number): Promise<void> {
        this.showLoading();

        const body = new URLSearchParams({
            action: eventsFilterData.action,
            nonce:  eventsFilterData.nonce,
            year:   String(year),
        });

        try {
            const response = await fetch(eventsFilterData.ajaxUrl, {
                method:  'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body:    body.toString(),
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const data = await response.json() as {
                success: boolean;
                data: { html?: string; message?: string };
            };

            if (!data.success) {
                this.showError(data.data?.message ?? eventsFilterData.i18n.error);
                return;
            }

            this.container!.innerHTML = data.data.html ?? '';
            this.animateCards();

        } catch (err) {
            console.error('[events-filter] Fetch error:', err);
            this.showError(eventsFilterData.i18n.error);
        }
    }

    private showLoading(): void {
        this.container!.innerHTML = `
            <div class="events-loading" aria-live="polite" role="status">
                <span class="spinner" aria-hidden="true"></span>
                <span class="sr-only">${eventsFilterData.i18n.loading}</span>
            </div>
        `;
    }

    private showError(message: string): void {
        this.container!.innerHTML = `<p class="events-error" role="alert">${message}</p>`;
    }

    private animateCards(): void {
        const cards = this.container!.querySelectorAll<HTMLElement>('.event-card');
        cards.forEach((card, index) => {
            card.style.opacity         = '0';
            card.style.transform       = 'translateY(16px)';
            card.style.transition      = 'opacity 0.3s ease, transform 0.3s ease';
            card.style.transitionDelay = `${index * 60}ms`;

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    card.style.opacity   = '1';
                    card.style.transform = 'translateY(0)';
                });
            });
        });
    }
}